// extracted by mini-css-extract-plugin
export default {"openWebsite":"styles-module__ar9W8","websiteIcon":"styles-module__zUQmD"};